export class portcalvm {

    PortId? :number;

    ShippingLineID? :number;

    VesselsId ?:number;    

    VoyageId?:number;

    FromDate :string;

    Todate :string;  
        
}